import PrivatePolicyPageRightPart from '../../components/PrivatePolicyPage/PrivatePolicyPageRightPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(PrivatePolicyPageRightPart);
